import React from 'react';
import Styles from './styles.module.css';
import { HiOutlineBookOpen } from "react-icons/hi2";
import { IoChevronForward } from "react-icons/io5";
import { pamphletData, pamphletUrl, pointData } from 'src/type';

type RecruitPointProps = {
  point: pointData;
  pamphlet: pamphletData;
  // 求人編集のプレビュー時のみ true。未入力の枠に例文（灰色）を出す。
  // 公開求人ページからは渡されないため、応募者には従来どおり何も出ない。
  preview?: boolean;
};

const POINT_PLACEHOLDERS = [
  "例）駅チカ・車通勤OKで通いやすい立地",
  "例）未経験から3年でスタイリストデビュー",
  "例）産休・育休の取得実績が豊富",
];

const RecruitPoint: React.FC<RecruitPointProps> = React.memo(({ point, pamphlet, preview }) => {

  const handleClick = () => {
    // 保存した時刻を末尾に付け、差し替えたパンフレットが古いまま表示されないようにする
    const url = pamphletUrl(pamphlet?.id ?? '', pamphlet?.version);
    window.open(url, "_blank");
  };

  const titles = [point.title1, point.title2, point.title3];

  return (
    <>
    {/* 白い1枚のカードに3つを区切り線で並べる(学生アプリの RecruitPoint と同じ) */}
    <div className={Styles.point}>
      {titles.map((title, i) => (
        <div key={i} className={Styles.point_row}>
          <div className={Styles.point_no}>
            <span className={Styles.point_label}>POINT</span>
            <span className={Styles.point_num}>{String(i + 1).padStart(2, "0")}</span>
          </div>
          {title
            ? <p>{title}</p>
            : <p className={preview ? Styles.placeholder : undefined}>
                {preview ? POINT_PLACEHOLDERS[i] : ""}
              </p>}
        </div>
      ))}
    </div>

    {(pamphlet && pamphlet.id !== "") && (
      <div onClick={handleClick} className={Styles.pamphlet}>
        <HiOutlineBookOpen className={Styles.pamphlet_icon} />
        <span className={Styles.pamphlet_text}>パンフレットを見る</span>
        <span className={Styles.pamphlet_pdf}>PDF</span>
        <IoChevronForward className={Styles.pamphlet_arrow} />
      </div>
    )}
    </>
  );
});

export default RecruitPoint;

